const SESSION_EXPIRED_EVENT = 'air-session-expired';

const emitSessionExpired = () => {
    if (typeof window !== 'undefined' && window.dispatchEvent) {
        window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
    }
};

const onSessionExpired = (handler) => {
    if (typeof window === 'undefined' || !window.addEventListener) {
        return () => {};
    }
    window.addEventListener(SESSION_EXPIRED_EVENT, handler);
    return () => window.removeEventListener(SESSION_EXPIRED_EVENT, handler);
};

export { SESSION_EXPIRED_EVENT, emitSessionExpired, onSessionExpired };
